import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { Button, Tooltip } from '@material-ui/core';
import { Delete, Edit, ToggleOn, ToggleOff, Link } from '@material-ui/icons';

import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from '_metronic/_partials/controls';
import { getAds, deleteAd, changeStatusAd } from 'api/ad';
import Table, { buttonsStyle } from 'app/components/tables/table';
import ConfirmDialog from 'app/components/dialogs/ConfirmDialog';
import { alertError, alertSuccess } from 'utils/logger';

export function AdsPage() {
	const [data, setData] = useState([]);
	const [adId, setAdId] = useState(null);
	const [selectedAd, selectAd] = useState(null);

	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		const adUrl = `https://apps.admob.com/v2/apps/5706576419/adunits/${elem.unitId}/edit`;
		return (
			<>
				<Tooltip title='View'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => window.open(adUrl, '_blank').focus()}>
						<Link />
					</Button>
				</Tooltip>
				<Tooltip title='Edit'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => history.push('/view-ad/' + cell)}>
						<Edit />
					</Button>
				</Tooltip>
				<Tooltip title={elem?.active ? 'Disable' : 'Enable'}>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => {
							selectAd(elem);
							setOpenConfirmDialog(1);
						}}>
						{elem?.active ? (
							<ToggleOff />
						) : (
							<ToggleOn style={{ color: 'red' }} />
						)}
					</Button>
				</Tooltip>
				<Tooltip title='Delete'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => {
							setAdId(cell);
							setOpenConfirmDialog(2);
						}}>
						<Delete />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: 'name', text: 'Name', sort: true },
		{ dataField: 'format', text: 'Format', sort: true },
		{ dataField: 'platform', text: 'Platform', sort: true },
		{ dataField: '_id', text: '', formatter: buttonFormatter },
	];

	useEffect(() => {
		getAds()
			.then((res) => {
				if (res.status === 200) {
					setData(res.data.map((s) => ({ ...s, id: s._id })));
					setRefresh(false);
				}
			})
			.catch((error) =>
				alertError({ error: error, customMessage: 'Could not get ads.' })
			);
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title='Ads list'>
					<CardHeaderToolbar>
						<button
							type='button'
							className='btn btn-primary'
							onClick={() => history.push('/view-ad')}>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={`Are you sure you want to ${
							selectedAd?.active ? 'disable' : 'enable'
						} this ad?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() =>
							changeStatusAd(selectedAd.id, !selectedAd?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: `${
												selectedAd?.active
													? 'Disabled!'
													: 'Enabled!'
											}`,
											customMessage: `Ad ${
												selectedAd?.active
													? 'disabled'
													: 'enabled'
											} successfully`,
										});
										setRefresh(true);
									}
								})
								.catch((error) =>
									alertError({
										error: error,
										customMessage: `Could not ${
											selectedAd?.active ? 'disable' : 'enable'
										} ad.`,
									})
								)
						}
					/>
					<ConfirmDialog
						title={'Are you sure you want to remove this ad?'}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() =>
							deleteAd(adId)
								.then((res) => {
									if (res.status === 204 || res.status === 200) {
										alertSuccess({
											title: 'Deleted!',
											customMessage:
												'Ad removed successfully.',
										});
										setRefresh(true);
									}
								})
								.catch((error) =>
									alertError({
										error: error,
										customMessage: 'Could not remove ad.',
									})
								)
						}
					/>
				</CardBody>
			</Card>
		</>
	);
}
